<template>
  <b-modal
    :title="creating? 'Crear Rol' : 'Editar Rol'"
    ref="modalEditionRol"
    hide-footer
    centered
  >
    <b-overlay :show="isSaving">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group">
            <label for="nombre">Nombre</label>
            <input
              type="text"
              class="form-control"
              id="nombre"
              v-model="rol.name"
              placeholder="Nombre del rol"
            >
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="descripcion">Descripción</label>
            <input
              type="text"
              class="form-control"
              id="descripcion"
              v-model="rol.description"
              placeholder="Descripción del rol"
            >
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="applications">Aplicación</label>
            <select
              id="applications"
              name="applications"
              class="form-control"
              v-model="rol.applicationId"
            >
              <option
                v-for="app in applications"
                :value="app.id"
                :key="'app-'+app.id"
              >
                {{ app.title }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group">
            <label for="webSopes">Ámbito</label>
            <select
              id="webSopes"
              name="applications"
              class="form-control"
              v-model="rol.scopeId"
            >
              <option
                v-for="scope in webSopes"
                :value="scope.id"
                :key="'scope-'+scope.id"
              >
                {{ scope.title }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-md-12">
          <button
            class="btn btn-primary"
            @click="saveRol"
            :disabled="!isValid"
          >
            Guardar
          </button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex';

import { applications, webSopes } from '@/febos/global/utils/configurations';
import { ioSaveCompanyRol, ioUpdateCompanyRol } from '@/febos/servicios/api/empresas.api';

export default {
  name: 'RolModal',
  data() {
    return {
      applications,
      webSopes,
      isSaving: false,
      rol: {
        rolId: undefined,
        name: '',
        description: '',
        applicationId: 'ED',
        scopeId: 'cloud'
      },
      creating: true
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    isValid() {
      return !!(
        this.rol.name
        && this.rol.description
        && this.rol.applicationId
        && this.rol.scopeId
      );
    }
  },
  methods: {
    async saveRol() {
      this.isSaving = true;
      const { rol } = this;
      try {
        if (this.creating) {
          await ioSaveCompanyRol(this.company.id, {
            nombre: rol.name,
            descripcion: rol.description,
            app: rol.applicationId,
            ambito: rol.scopeId
          });
        } else {
          await ioUpdateCompanyRol(this.company.id, rol.rolId, {
            nombre: rol.name,
            descripcion: rol.description,
            app: rol.applicationId,
            ambito: rol.scopeId
          });
        }
        this.$emit('saveRol', this.rol);
        this.rol = {
          rolId: undefined,
          name: '',
          description: '',
          applicationId: 'ED',
          scopeId: 'cloud'
        };
        this.$refs.modalEditionRol.hide();
        this.isSaving = false;
      } catch (e) {
        console.error(e);
        this.isSaving = false;
      }
    },
    open(rol) {
      if (rol) {
        this.rol = {
          rolId: rol.rolId,
          name: rol.nombre,
          description: rol.descripcion,
          applicationId: rol.app,
          scopeId: rol.ambito
        };
      } else {
        this.rol = {};
      }
      this.creating = !rol;
      this.$refs.modalEditionRol.show();
    },
    hide() {
      this.$refs.modalEditionRol.hide();
    }
  }
};
</script>

<style scoped>

</style>
